import { ProgressIndicator } from '@jarvis/react-setup-and-onboarding-addons'
import React from 'react'

import {
  FullscreenBackdropContainer,
  SpinnerContainer,
} from './FullscreenSpinnerPage.styled'
export type FullscreenSpinnerPageProps = {
  elevated?: boolean
}

export function FullscreenSpinnerPage({
  elevated,
}: FullscreenSpinnerPageProps) {
  const spinner = (
    <SpinnerContainer>
      <ProgressIndicator
        data-testid="spinner-circular"
        appearance="circular"
        behavior="indeterminate"
        size="large"
      />
    </SpinnerContainer>
  )

  return elevated ? (
    <FullscreenBackdropContainer data-testid="elevated-background">
      {spinner}
    </FullscreenBackdropContainer>
  ) : (
    spinner
  )
}
